import React, { useState } from 'react';

const withMultiInputStateHandlersHOCGenerator = (Component) => {
  function WithMultiInputStateHandlersHOC(props) {
    const [validationMessage, setValidationMessage] = useState(null);
    const [inputValue, setInputValue] = useState('');

    // Handlers
    const resetValidationMessage = () => {
      setValidationMessage(null);
    };
    const resetInputValue = () => {
      setInputValue('');
    };

    return (
      <Component
        {...props}
        validationMessage={validationMessage}
        inputValue={inputValue}
        setValidationMessage={setValidationMessage}
        resetValidationMessage={resetValidationMessage}
        setInputValue={setInputValue}
        resetInputValue={resetInputValue}
      />
    );
  }

  return WithMultiInputStateHandlersHOC;
};

const withMultiInputStateHandlers = () => (Component) => withMultiInputStateHandlersHOCGenerator(Component);

export default withMultiInputStateHandlers;
